(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .directive('comparisonChartTitle', function () {
        return {
          restrict: 'E',
          controller : 'ComparisonChartTitleCtrl as vm',
          bindToController: true,
          templateUrl : 'StandardReports/Comparisons/ComparisonChartTitle/ComparisonChartTitle.tmpl.html',
          scope: {
            options: '='
          },
          link: function (scope) {
            scope.$watch('vm.options', function(newVal) {
              if (newVal) {
                scope.vm.updateLegendCheckbox();
              }
            }, true);

          }
        };
      });

})();